export default {
    path: '/Ali-pay-cart',
    meta: {
        title: '付款',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/Ali-pay-cart`),
}



// WEBPACK FOOTER //
// ./src/views/ByOtherCart/router.js